import compose from "./compose";
import list from "./list";
import mergeAll from "./mergeAll";

const mergeArgs = compose(mergeAll, list);

export default mergeArgs;
